/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Finish_HInputs */

const en_funnel_finish_h = /** @type {(inputs: Funnel_Finish_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start your free trial`)
};

const es_funnel_finish_h = /** @type {(inputs: Funnel_Finish_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza tu prueba gratuita`)
};

/**
* | output |
* | --- |
* | "Start your free trial" |
*
* @param {Funnel_Finish_HInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_finish_h = /** @type {((inputs?: Funnel_Finish_HInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Finish_HInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_finish_h(inputs)
	return en_funnel_finish_h(inputs)
});